import React from "react";
import { actions } from "react-redux-form";
import { toast } from "react-toastify";
import qs from "qs";
import irelandApi from "../irelandApi";
import { destandard } from "../utils/commonFunctions";
import { history } from "../store";
import ToastMessage from '../components/common/toast-message'
import {
  GET_ADMIN_PROMOTIONAL_BANNER_META_FULFILLED,
  GET_ADMIN_PROMOTIONAL_BANNER_META_PENDING,
  GET_ADMIN_PROMOTIONAL_BANNER_META_REJECTED
} from "../reducers/promotionalBannersReducer";

export const getPromotionalBannersForNewOrderPage = (dispatch) => {
  dispatch({ type: "GET_PROMOTIONAL_BANNERS_FOR_NEW_ORDER_PAGE_PENDING", payLoad: [] });

  return irelandApi.get(`/api/promotional_banners`)
    .then((response) => {
      dispatch({type: "GET_PROMOTIONAL_BANNERS_FOR_NEW_ORDER_PAGE_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PROMOTIONAL_BANNERS_FOR_NEW_ORDER_PAGE_REJECTED', payLoad: error.data})
    })
};

export const getPromotionalBanners = (displayFromDate, displayToDate, group, category) => (dispatch) => {
  dispatch({
    type: "GET_PROMOTIONAL_BANNER_LIST_PENDING",
    payLoad: []
  });

  const q = {
    display_from_date: displayFromDate,
    display_to_date: displayToDate,
    group_id: group,
    category_id: category
  };

  return irelandApi.get(`/api/admin/promotional_banners?${qs.stringify({ q }, { encodeValuesOnly: true })}`)
    .then((response) => {
      dispatch({type: "GET_PROMOTIONAL_BANNER_LIST_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_PROMOTIONAL_BANNER_LIST_REJECTED', payLoad: error.data})
    });
};

export const getPromotionalBanner = (id) => (dispatch) => {
  dispatch({type: "GET_PROMOTIONAL_BANNER_PENDING"});
  return irelandApi.get(`/api/admin/promotional_banners/${id}`)
    .then((response) => {
      const data = destandard({
        //photo: response.data.data.attributes.links.photo,
        ...response.data.data.attributes
      });
      dispatch({type: "GET_PROMOTIONAL_BANNER_FULFILLED", payLoad: data});

      data.default = data.default.toString();
      return Promise.resolve(data);
    })
    .catch((error) => {
      toast.warn(<ToastMessage iconStyle="warning"
                               message={`Unable to get promotional banner.`}/>, {autoClose: 2000});
      dispatch({type: 'GET_PROMOTIONAL_BANNER_REJECTED', payLoad: "error"})
    })
};

export const deletePromotionalBanner = (id) => (dispatch) => {
  dispatch({type: "DELETE_PROMOTIONAL_BANNER_PENDING"});
  return irelandApi.delete(`/api/admin/promotional_banners/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Promotional banner has been deleted successfully"/>);
      dispatch({type: "DELETE_PROMOTIONAL_BANNER_FULFILLED", payLoad: id});
      dispatch(getPromotionalBanners());
    })
    .catch((error) => {
      const data = {
        ...error.response.data.errors
      };
      let message = "An error occured during delete promotional banner";
      if (data.has_items) {
        message = data.has_items;
      }
      toast.error(<ToastMessage iconStyle="error" message={message}/>);
      dispatch({type: 'DELETE_PROMOTIONAL_BANNER_REJECTED', payLoad: error.data});

      return Promise.reject(data);
    })
};

export const savePromotionalBanner = (payLoad) => dispatch => {
  dispatch({type: "SAVE_PROMOTIONAL_BANNER_PENDING"});
  let formData = new FormData();
  payLoad = removeNullFields(payLoad);

  payLoad["group_ids"] = payLoad["group_ids"].map(curr => {
    return curr.value;
  });

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'group_ids') {
      payLoad[key].forEach(value => {
        formData.append(`promotional_banner[group_ids][]`, value)
      });
    } else {
      formData.append(`promotional_banner[${key}]`, payLoad[key])
    }
  });

  return irelandApi.post(`/api/admin/promotional_banners`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Promotional banner has been saved successfully"/>);
      history.push('/admin/promotional_banners');
    })
    .catch((error) => {
      const errorData = error.response.data.errors;
      let toastMessage = "An error occurred during save promotional banner";
      if (error.response.data.errors) {
        const errors = error.response.data.errors;
        if (errors.overlap_error) {
          toastMessage = errors.overlap_error;
        }
        ['display_to_date', 'groups',].forEach((field) => {
          if (errors[field]) {
            dispatch(actions.setErrors(`deep.admin_promotional_banner_save.${field}`, errors[field]));
          }
        });
      }
      toast.error(<ToastMessage iconStyle="error" message={toastMessage}/>);
      dispatch({type: 'SAVE_PROMOTIONAL_BANNER_REJECTED', payLoad: errorData});
    })
};

export const updatePromotionalBanner = (id, payLoad) => dispatch => {
  dispatch({type: "SAVE_PROMOTIONAL_BANNER_PENDING"});

  let formData = new FormData();
  payLoad = removeNullFields(payLoad);

  if (payLoad["group_ids"]) {
    payLoad["group_ids"] = payLoad["group_ids"].map(curr => {
      return curr.value;
    });
  }

  Object.keys(payLoad).forEach(key => {
    if (`${key}` == 'group_ids') {
      payLoad[key].forEach(value => {
        formData.append(`promotional_banner[group_ids][]`, value)
      });
    } else if (`${key}` == 'special_reward' && payLoad[key] === null) {
      formData.append(`promotional_banner[${key}]`, false);
    } else {
      formData.append(`promotional_banner[${key}]`, payLoad[key])
    }
  });

  return irelandApi.patch(`/api/admin/promotional_banners/${id}`, formData)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Promotional banner has been saved successfully"/>);
      history.push('/admin/promotional_banners');
    })
    .catch((error) => {
      const errorData = error.response.data.errors;
      let toastMessage = "An error occurred during save promotional banner";
      if (error.response.data.errors) {
        const errors = error.response.data.errors;
        if (errors.overlap_error) {
          toastMessage = errors.overlap_error;
        }
        ['display_to_date', 'groups', ].forEach((field) => {
          if (errors[field]) {
            dispatch(actions.setErrors(`deep.admin_promotional_banner_save.${field}`, errors[field]));
          }
        });
      }
      toast.error(<ToastMessage iconStyle="error" message={toastMessage}/>);
      dispatch({type: 'SAVE_PROMOTIONAL_BANNER_REJECTED', payLoad: errorData});
    })
};

export const getPromotionalBannerMeta = () => (dispatch) => {
  dispatch({ type: GET_ADMIN_PROMOTIONAL_BANNER_META_PENDING });

  return irelandApi.get(`/api/admin/promotional_banners/new`)
    .then((response) => {
      dispatch({
        type: GET_ADMIN_PROMOTIONAL_BANNER_META_FULFILLED,
        payload: response.data
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_ADMIN_PROMOTIONAL_BANNER_META_REJECTED,
        payload: error.response.data
      });
      toast.error(
        <ToastMessage iconStyle="error" message="An error occurred during create promotional banner" />
      );
    });
};

const removeNullFields = (data) => {
  const copy = {...data};
  return copy;
};




// WEBPACK FOOTER //
// ./src/actions/promotional_banners.js